import { AudioLines, Film, ImagePlus } from "lucide-react";
import type { AssetType } from "@/lib/api";
import { AssetThumb } from "@/components/media/AssetThumb";
import { cn } from "@/lib/utils";

interface Props {
  assetId: string;
  /** Poster/thumbnail key when the reference carries one; images fall back to their own key. */
  storageKey?: string | null;
  thumbnailKey?: string | null;
  label: string;
  type?: AssetType;
  className?: string;
  onPreview: () => void;
}

/** A large, tappable reference tile; the parent owns the single lightbox. */
export function ReferencePreviewButton({ assetId, storageKey, thumbnailKey, label, type = "image", className, onPreview }: Props) {
  const Icon = type === "audio" ? AudioLines : type === "video" ? Film : ImagePlus;
  // Video/audio previews only through an image thumbnail; never load the media itself into an <img>.
  const posterKey = thumbnailKey ?? (type === "image" ? storageKey ?? null : null);
  const byId = type === "image" && !posterKey ? assetId : null;
  return (
    <button
      type="button"
      aria-label={`Preview ${label}`}
      title={`Preview ${label}`}
      onClick={onPreview}
      className={cn(
        "inline-flex shrink-0 items-center justify-center overflow-hidden rounded-lg bg-studio-card focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-studio-accent",
        className
      )}
    >
      <AssetThumb type="image" storageKey={posterKey} assetId={byId} alt={label} fallback={<Icon className="h-5 w-5 text-studio-accent" />} />
    </button>
  );
}
